import { Resource } from '@prismamedia/one-crud-react';
import { NewsletterConfig } from './newsletter.config';
import { SectionsResource } from './sections.config';

export const CampaignConfig: Resource = {
  singular: 'campaign',
  plural: 'campaigns',
  basePath: 'campaign',
  keyProperty: 'id',
  linkedResources: [
    {
      field: 'newsletter',
      resource: NewsletterConfig,
    },
    {
      field: 'sections',
      resource: SectionsResource,
    },
  ],
};
